/**
 * Converts a `ud_locale`-style locale (e.g. `ja_JP`) to the `Accept-Language`
 * header format (e.g. `ja-JP`).
 */
export function toAcceptLanguage(locale: string): string {
    return locale.replace('_', '-');
}
